<template>
  <router-view module="sales" />
</template>

<script>
export default {
  name: "ProspectsSales"
};
</script>
